import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { debounce } from '../../../utils/debounce';
import Box from '../../layout/Box';
import './styles.scss';

class TimePicker extends Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultTime: PropTypes.string.isRequired,
    editing: PropTypes.bool.isRequired,
  };

  handleChange = debounce(() => {
      this.props.onChange(`${this.hours.value}:${this.minutes.value}`);
    },
    300,
  );

  render() {
    const [hours, minutes] = this.props.defaultTime.split(':');

    if (this.props.editing) {
      return (
        <Box className="time-picker"
             direction="row"
             alignItems="center"
             justifyContent="space-around">
          <input type="number" min={0} max={23} step={1} name="hours" id="hours"
                 ref={(input) => this.hours = input}
                 onChange={this.handleChange} defaultValue={hours}/>:
          <input type="number" min={0} max={45} step={15} name="minutes" id="minutes"
                 ref={(input) => this.minutes = input}
                 onChange={this.handleChange} defaultValue={minutes}/>
        </Box>
      );
    } else {
      return (
        <div className="time-picker">
          {hours}:{minutes}
        </div>
      );
    }
  }
}

export default TimePicker;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/TimePicker/index.js